<div *ngIf="reportType == 'briefly1'">
  <div class="container" id="print-section" style="padding: 20px;">
    <table class="table table-bordered" style="width: 100%; border-collapse: collapse; font-size: 14px;">
      <thead>
        <tr style="text-align: center; font-weight: bold;">
          <th colspan="1" style="border: 1px solid #000;">Vivek Saptahik</th>
          <th colspan="3" style="border: 1px solid #000;">Issue Seller Payment Receipt Ledger</th>
          <th colspan="1" style="border: 1px solid #000;">Briefly</th>
          <th colspan="2" style="border: 1px solid #000;">Date</th>
        </tr>
        <tr style="text-align: center;">
          <th colspan="1" style="border: 1px solid #000;">Datewise</th>
          <th colspan="1" style="border: 1px solid #000;">Date</th>
          <th colspan="2" style="border: 1px solid #000;">
            From: {{ startDate | date: 'dd-MM-yyyy' }} To: {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
          <th colspan="3" style="border: 1px solid #000;">Page No</th>
        </tr>
        <tr style="font-weight: bold; text-align: center;">
          <th style="border: 1px solid #000;">Receipt No</th>
          <th style="border: 1px solid #000;">Receipt Date</th>
          <th style="border: 1px solid #000;">Entry Date</th>
          <th style="border: 1px solid #000;">Issue Seller Name</th>
          <th style="border: 1px solid #000;">Representative Name</th>
          <th style="border: 1px solid #000;">Office Representative Name</th>
          <th style="border: 1px solid #000;">Received Amount</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let repGroup of advtBrieflyFormBeans">
          <tr *ngFor="let data1 of repGroup.rep_data">
            <td style="border: 1px solid #000;">{{ data1.rcpt_no }}</td>
            <td style="border: 1px solid #000;">{{ data1.rcpt_date }}</td>
            <td style="border: 1px solid #000;">{{ data1.entry_date }}</td>
            <td style="border: 1px solid #000;">{{ data1.issue_seller_name }}</td>
            <td style="border: 1px solid #000;">{{ data1.rep_name }}</td>
            <td style="border: 1px solid #000;">{{ data1.off_rep_name }}</td>
            <td style="text-align: end; border: 1px solid #000;">{{ data1.rcv_amt }}</td>
          </tr>
        </ng-container>

        <!-- Only one grand total row -->
        <tr style="font-weight: bold; background-color: #f1f1f1;">
          <td colspan="6" style="text-align: right; border: 1px solid #000;">Total:</td>
          <td style="text-align: end; border: 1px solid #000;">Rs {{ advtBrieflyTotal }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Action Buttons -->
  <div style="text-align: right; margin: 20px 0;">
    <button class="noPrint" mat-raised-button color="primary"
      (click)="exportExcel('Payment_Receipt_Reg_Brifly_Report')" style="margin-right: 10px;">
      Export
    </button>

    <button class="noPrint" mat-raised-button color="primary"
      ngxPrint printSectionId="print-section" [useExistingCss]="true" style="margin-right: 10px;">
      Print
    </button>

    <button class="noPrint" mat-button mat-dialog-close>
      Close
    </button>
  </div>
</div>
